import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription ,  Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionStorageService } from 'ngx-webstorage';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { NgxSpinnerService } from "ngx-spinner";

import { AuthTokenModel, LoginModel } from './models';
import { LoginService } from './login.service';
import { NavMenuService } from '../nav-menu/nav-menu.service';
import { AuthenticationService } from '../core';
import { NgbAppropriateUseModalContent } from '../shared/components/modal/appropriate-use-modal.component';
import { NgbInitialPasswordResetModalContent } from '../shared/components/modal/initial-password-reset-modal.component';
import { ToastrService } from 'ngx-toastr';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [LoginService]
})
export class LoginComponent implements OnInit, OnDestroy {
  private subscription: Subscription;

  brandNew: boolean;
  credentials: LoginModel = {
    username: '',
    password: '',
    email: '',
    confirmationcode: '',
    challenge: '',
    challengeParams: {},
    session: ''
  };
  errors: string = null;
  isRequesting: boolean = false;
  redirectUrl: string = '';
  submitted: boolean = false;
  authCode: string;
  ssoUri: string;
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  private onIdleTimeout$: Subscription;
  private onIdleStart$: Subscription;
  private onIdleEnd$: Subscription;
  private keepAlivePing$: Subscription;

  public mode: string = "Login";
  public mfaqrcode: string = "http://www.google.com/"
  private username: string = "";
  private password: string = "";
  private sessionID: string = "";

  constructor(
    private auth: AuthenticationService,
    private loginService: LoginService,
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private session: SessionStorageService,
    private navmenuService: NavMenuService,
    private idle: Idle,
    private keepalive: Keepalive,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) { }

  //Used to define the form and validations for the change password form.
  public changef: UntypedFormGroup = new UntypedFormGroup({
    password: new UntypedFormControl(null, [Validators.required, Validators.minLength(8), Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$*.{}?"!@#%&/,><\':;|_~`^\\]\\[\\)\\(]).{1,}')]),
    confirmpassword: new UntypedFormControl(null),
  }, this.pwdMatchValidator);

  pwdMatchValidator(frm: UntypedFormGroup) {
    return frm.get('password').value === frm.get('confirmpassword').value
      ? null : { 'mismatch': true };
  }

  ngOnInit() {
    this.redirectUrl = this.route.snapshot.queryParams['returnUrl'] || "";
    this.logout();
    this.loginService.GetSSOUrl()
      .subscribe(data => {
        this.ssoUri = data;
        console.log(data);
        //window.open(SSOUri, '_self');    

      }, error => {
        console.log(error);
      }); 
    //this.subscription = this.route.queryParams.subscribe(
    //  (param: any) => {
    //    this.brandNew = param['brandNew'];
    //    this.credentials.email = param['email'];
    //  });
    this.authCode = this.route.snapshot.queryParamMap.get('code');
    if (this.authCode) {
      this.ssoCompletion();
    }
    console.log(this.authCode);
  }

  ngOnDestroy() {
    // prevent memory leak by unsubscribing
  }

  changePassword({ value, valid }: { value, valid: boolean }) {
    var lm = new LoginModel();
    lm.username = this.username;
    lm.password = this.password;
    lm.session = this.sessionID;
    lm.challenge = 'change_password';
    lm.challengeParams = {
      newPassword: value.password,
      accessToken: this.auth.accessToken
    };

    this.login({ value: lm, valid: true});
  }

  mfaSetup({ value, valid }: { value, valid: boolean }) {
    var lm = new LoginModel();
    lm.username = this.username;
    lm.password = this.password;
    lm.session = this.sessionID;
    lm.challenge = 'mfa_setup';
    lm.challengeParams = {
      mfa_code: value.mfa,
      accessToken: this.auth.accessToken
    };

    this.login({ value: lm, valid: true });
  }

  mfaCode({ value, valid }: { value, valid: boolean }) {
    var lm = new LoginModel();
    lm.username = this.username;
    lm.password = this.password;
    lm.session = this.sessionID;
    lm.challenge = 'mfa';
    lm.challengeParams = {
      mfa_code: value.mfa
    };

    this.login({ value: lm, valid: true });
  }

  login({ value, valid }: { value: LoginModel, valid: boolean }) {

    let observable: Observable<AuthTokenModel>;
    let acceptableUseResult: Observable<boolean>;

    this.spinner.show();

    observable = this.loginService.login(value);

    observable.subscribe(
      (authTokenModel) => {
        let openAcceptDialog: Boolean = false;

        //if this is the first time thru this process, save data for future calls to login challenges
        if (this.username == '') {
          this.username = value.username;
          this.password = value.password;
        }
        this.sessionID = authTokenModel.session;

        // Turn off the spinner
        this.spinner.hide();

        if (authTokenModel.challenge == 'none') {
          openAcceptDialog = true;
        }
        else if (authTokenModel.challenge == 'change_password') {
          //Save the access token as it may be needed for the change password process
          this.auth.accessToken = authTokenModel.access_token;
          this.mode = "ChangePassword";
        }
        else if (authTokenModel.challenge == 'changepassword_success') {
          this.mode = "Login";
          this.toastr.success('Password change successful. Please login again.', 'Authentication', { closeButton: true });
        }
        else if (authTokenModel.challenge == 'mfa_setup') {
          this.mode = "MFASetup";
          this.mfaqrcode = authTokenModel.challengeParams['QRCode'];
          this.auth.accessToken = authTokenModel.access_token;
        }
        else if (authTokenModel.challenge == 'mfa_setup_success') {
          this.mode = "Login";
          this.toastr.success('MFA setup successful. Please login again.', 'Authentication', { closeButton: true });
        }
        else if (authTokenModel.challenge == 'mfa_request') {
          this.mode = "MFA";
        }

        if (openAcceptDialog) {
          // Make the user agree to the acceptable use dialog
          this.openAcceptableUseDialog(authTokenModel);
        }
      },
      (err) => {
        this.spinner.hide();
        if (this.mode == "Login") {
          this.errors = "You have entered an invalid username or password";
        }
        else if (this.mode == "MFASetup") {
          this.errors = "Error Setting up MFA or invalid code";
        }
        this.logout();
      }
    )
  }

  ssoLogin() {    
    //configure this uri to come from a configurable location
    window.open(this.ssoUri, '_self');
    //window.open('https://devweb-sceacp.auth.us-east-2.amazoncognito.com/oauth2/authorize?client_id=634ilbmt8atkqh24q881669mq0&response_type=code&scope=email+openid&redirect_uri=https://devweb.sceacp.com/login/','_self');    
  }

  ssoCompletion() {
    let observable: Observable<AuthTokenModel>;
    let acceptableUseResult: Observable<boolean>;
    observable = this.loginService.ssoLogin(this.authCode);

    observable.subscribe(
      (authTokenModel) => {
        // Make the user agree to the acceptable use dialog
        this.openAcceptableUseDialog(authTokenModel);
      },
      (err) => {
        this.errors = "Unsuccessful login attempt. Please contact your administrator.";
        this.logout();
      }
    )
  }

  openAcceptableUseDialog(authTokenModel: AuthTokenModel) {
    this.errors = null;
    const modalRef = this.modalService.open(NgbAppropriateUseModalContent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.title = "Appropriate Use";
    modalRef.result.then((result) => {
      if (result === 'Agree') {
        console.log(authTokenModel);
        this.auth.accessToken = authTokenModel.access_token;
        this.auth.idToken = authTokenModel.id_token;
        this.auth.refreshToken = authTokenModel.refresh_token;
        this.auth.userRoles = authTokenModel.permissions;
        this.auth.app_version = authTokenModel.app_version;
        this.auth.app_environment = authTokenModel.app_environment;
        this.auth.sso_user = authTokenModel.sso_user;
        // This is needed in the special case where a user has forgotten his/her password. The initial menu
        // set is the basic non-admin set. If the user resetting his/her password has the Admin role - the menus
        // need to be reset.
        this.navmenuService.getMenuItems();

        this.setupTimeout();

        this.router.navigate(['/']);
      } else {
        this.errors = "You must agree to the Appropriate Use policy to continue.";
        this.logout();
      }
    }, (reason) => {
      this.errors = "You must agree to the Appropriate Use policy to continue.";
      this.logout();
    });
  }

  logout() {
    if (this.auth.isLoggedIn) {
      this.auth.accessToken = undefined;
      this.auth.idToken = undefined;
      this.auth.refreshToken = undefined;
      this.auth.userRoles = undefined;
      this.auth.sso_user = undefined;
      if (this.onIdleEnd$) this.onIdleEnd$.unsubscribe();
      if (this.onIdleTimeout$) this.onIdleTimeout$.unsubscribe();
      if (this.onIdleStart$) this.onIdleStart$.unsubscribe();
      if (this.keepAlivePing$) this.keepAlivePing$.unsubscribe();
      this.clearSession();
    }
  }

  setupTimeout() {
        // sets an idle timeout of 1 hour 30 minutes
        this.idle.setIdle(5400);
        // sets a timeout period of 30 minutes. after a total of 2 hours of inactivity, the user will be considered timed out.
        this.idle.setTimeout(1800);
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    
        this.onIdleEnd$ = this.idle.onIdleEnd.subscribe(() => { 
          this.idleState = 'No longer idle.'
          console.log(this.idleState);
          this.reset();
        });
        
        this.onIdleTimeout$ = this.idle.onTimeout.subscribe(() => {
          this.idleState = 'Timed out!';
          this.timedOut = true;
          console.log(this.idleState);
          this.logout();
          this.router.navigate(['/login']);
        });
        
        this.onIdleStart$ = this.idle.onIdleStart.subscribe(() => {
            this.idleState = 'You\'ve gone idle!'
            console.log(this.idleState);
        });
        
        // this.idle.onTimeoutWarning.subscribe((countdown) => {
        //   this.idleState = 'You will time out in ' + countdown + ' seconds!'
        //   console.log(this.idleState);
        // });
    
        // sets the ping interval to 5 minutes;
        this.keepalive.interval(300);
    
        this.keepAlivePing$ = this.keepalive.onPing.subscribe(() => this.lastPing = new Date());
    
        this.reset();
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  Confirm() {
    var c = false;
  }

  clearSession() {
    this.auth.accessToken = '';
    this.auth.idToken = '';
    this.auth.refreshToken = '';
    this.auth.userRoles = [];
    this.auth.sso_user = undefined;
    this.session.clear();
  }

  showForgotPassword() {
    this.router.navigate(['/forgot-password']);
  }
}
